module.exports = __webpack_public_path__ + "static/img/shopping-cart.886b81e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shopping-cart.png
// module id = qyKB
// module chunks = 1